import { Alert, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import axios from "axios";
import * as React from "react";
import { LoadingWrapper } from "../../components/LoadingWrapper";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

interface PurchasesState {
    loaded: boolean;
    data: any[];
}

interface Props {
    playerId: string;
    activeEnv: any;
    classes: any;
}

export class PlayerChatHistory extends React.Component<Props, PurchasesState> {

    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            data: [],
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        try {
            const response = await axios.get(
                `${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/chat_history`,
                {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                },
            );
            this.setState({
                data: response.data,
            });
        } catch (e) {
            PopupMessage.error("Failed to load chat history: " + e.message);
        }

        this.setState({
            loaded: true,
        });
    }

    renderRows() {
        if (!this.state.loaded) {
            return <TableRow key="loading-row">
                <TableCell colSpan={2}>
                    {Helpers.renderSkeletonRows(3, 50)}
                </TableCell>
            </TableRow>
        }

        if ((this.state.data || []).length === 0) {
            return <TableRow key="records_not_found">
                <TableCell colSpan={2}>
                    <Alert severity="info">No chat messages found</Alert>
                </TableCell>
            </TableRow>
        }

        return (this.state.data || []).map(row => (
            <TableRow key={row.id}>
                <TableCell align="left">{row.message}</TableCell>
                <TableCell align="center">{Helpers.formatDateWithTime(row.created_at)}</TableCell>
            </TableRow>
        ))
    }

    render() {
        return (
            <Paper elevation={0}>
                <LoadingWrapper loading={!this.state.loaded}>
                    <Table style={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Message</TableCell>
                                <TableCell align="center" style={{ width: 200 }}>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.renderRows()}
                        </TableBody>
                    </Table>
                </LoadingWrapper>
            </Paper>
        );
    }
}
